// extracted by mini-css-extract-plugin
export default {"container":"results_container__3rgEK","--collapsed":"results_--collapsed__G6CPf","scroll-area":"results_scroll-area__Sij6o"};